import styled from 'styled-components';
import { themeGet } from '@magalu/stereo-ui-styles';
import Text from '../../atoms/Text';
export const Header = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  padding: 16px;
  border-bottom: 3px solid #eee;
`;
export const Centered = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Title = styled(Text)`
  text-align: center;
  font-weight: ${props => themeGet('fontWeights.medium')(props)};
  font-size: ${props => themeGet('fontSizes.2')(props)}px;
`;